import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var logoComponentName = 'QuantumLogo';
export function getLogoUtilityClass(slot) {
    return generateUtilityClass(logoComponentName, slot);
}
export var logoClasses = generateUtilityClasses(logoComponentName, ['root', 'svg']);
